
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    modelValue: String
  }
})
export default class Upload extends Vue {
  modelValue!: string;

  updateUrl(url: string) {
    this.$emit("update:modelValue", url);
  }

  uploadFile(files: any) {
    const url = URL.createObjectURL(files[0]);
    this.updateUrl(url);
  }
}
